import { DocumentMultiReceiptEntity } from '../../../../generated-api';
import { formDataToEntity as receiptFormDataToEntity } from '../formDataToEntity';
import { FormResult as ReceiptFormResult } from '../types';

type FormResult = {
  resultReceipts: Record<number, ReceiptFormResult>;
};
export function formDataToEntity(data: FormResult): DocumentMultiReceiptEntity {
  const receipts = Object.values(data.resultReceipts);
  const newReceipts = receipts.map((receipt) => receiptFormDataToEntity(receipt));
  return { receipts: newReceipts, type: 'multi_receipt' };
}
